export type NetInfoLikeState = {
  isConnected?: boolean | null;
  isInternetReachable?: boolean | null;
} | null | undefined;

/**
 * NetInfo fields can be `null` on some platforms (including initial load) to
 * indicate an "unknown" state. We should only consider the app offline when
 * reachability is explicitly reported as `false`.
 */
export function deriveIsOnlineFromNetInfoState(state: NetInfoLikeState): boolean {
  if (!state) return true;
  return state.isConnected !== false && state.isInternetReachable !== false;
}

